import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import { PlatformType, underlayImageParam } from '../../../common';
import { ImgQuery } from '../../services';
import { getImgUrlByPlatform } from '../../utils';
import { AbstractEmailCollectorDialogService } from '../../services/abstract-email-collector-dialog.service';
import { AbstractPageScreenService } from '../page-screen/abstract-page-screen.service';
import { SpotlightViewModel } from './spotlight-tray.view-model';

@Component({
  selector: 'osn-shared-spotlight-tray',
  templateUrl: './spotlight-tray.component.html',
  styleUrls: ['./spotlight-tray.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpotlightTrayComponent implements OnInit {
  public imgQuery: ImgQuery;
  public fallbackUrl: string;
  constructor(
    private readonly emailCollectorDialogService: AbstractEmailCollectorDialogService,
    private readonly pageScreenService: AbstractPageScreenService,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  @Input() public vm: SpotlightViewModel;
  @Input() public aspectRatio: string;
  public underlayImageParam = underlayImageParam;

  public ngOnInit(): void {
    const mobileImg = getImgUrlByPlatform(PlatformType.Mobile, this.vm.imageUrlsByPlatform);
    const tabletImg = getImgUrlByPlatform(PlatformType.Tablet, this.vm.imageUrlsByPlatform);
    const desktopImg = getImgUrlByPlatform(PlatformType.Web, this.vm.imageUrlsByPlatform);
    this.imgQuery = {
      XS: { url: mobileImg },
      SM: { url: tabletImg },
      MD: { url: desktopImg },
      LG: { url: desktopImg },
      XL: { url: desktopImg },
    };
  }
  public onSignupClick(buttonText: string) {
    this.pageScreenService.measureSpotlightButtonClick(buttonText);
    this.emailCollectorDialogService.openEmailCollectorPopup();
  }
}
